import GenAiCard from './GenAiCard'

export default GenAiCard
